'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.replaceEntity = replaceEntity;
exports.createEntity = createEntity;
exports.insertEntity = insertEntity;
exports.exportEntity = exportEntity;

var _draftJs = require('draft-js');

function replaceEntity(editorState, selection, text, entity) {
  var content = editorState.getCurrentContent();
  var insertContent = _draftJs.Modifier.replaceText(content, selection, text, {}, entity);

  var InsertSpaceContent = _draftJs.Modifier.insertText(insertContent, insertContent.getSelectionAfter(), ' ');
  return _draftJs.EditorState.push(editorState, InsertSpaceContent, 'replace-entity');
}

function createEntity(entityType, data) {
  var entityMode = arguments.length <= 2 || arguments[2] === undefined ? 'IMMUTABLE' : arguments[2];

  return _draftJs.Entity.create(entityType, entityMode, data || {});
}

function insertEntity(editorState, entityType, data) {
  var entityMode = arguments.length <= 3 || arguments[3] === undefined ? 'IMMUTABLE' : arguments[3];

  var selection = editorState.getSelection();
  var content = editorState.getCurrentContent();
  var entityKey = createEntity(entityType, data, entityMode);
  var insertContent = _draftJs.Modifier.insertText(content, selection, ' ', {}, entityKey);

  var InsertSpaceContent = _draftJs.Modifier.insertText(insertContent, insertContent.getSelectionAfter(), ' ');

  var newEditorState = _draftJs.EditorState.push(editorState, InsertSpaceContent, 'insert-entity');
  return _draftJs.EditorState.forceSelection(newEditorState, InsertSpaceContent.getSelectionAfter());
}

function exportEntity(entityData) {
  console.log('> exportEneity', entityData);
  return '' + entityData.emoji.shortCut;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-editor-plugin-emoji@0.2.9@rc-editor-plugin-emoji/lib/util.js
// module id = 95
// module chunks = 0 1 2